import { render, staticRenderFns } from "./EditorSettings.vue?vue&type=template&id=74fa0e50&scoped=true"
import script from "./EditorSettings.vue?vue&type=script&lang=js"
export * from "./EditorSettings.vue?vue&type=script&lang=js"
import style0 from "./EditorSettings.vue?vue&type=style&index=0&id=74fa0e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa0e50",
  null
  
)

export default component.exports